import type {
  ChatSenderRole,
  ChatThreadStateValue,
} from '@/api/chat-client';

// =============================================================================
// chat-format.ts — Libellés FR + formats du chat (R15-COM-02). Sens TOUJOURS textuel.
// =============================================================================
// WCAG 2.1 AA : chaque état/rôle porte un LIBELLÉ TEXTE explicite (la couleur n'est jamais le seul
// porteur d'information). Aucune règle métier ici : mise en forme pure (dates, libellés d'affichage).

/** Formate un instant ISO en date + heure FR courtes, ou « — » si absent. */
export function formatDateTime(iso: string | null): string {
  if (iso === null) {
    return '—';
  }
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleString('fr-FR', {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Libellé FR de l'état d'un fil (parité base) — jamais une couleur seule (WCAG). */
export function threadStateLabel(state: ChatThreadStateValue): string {
  switch (state) {
    case 'Provisionne':
      return 'Provisionné';
    case 'Actif':
      return 'Actif';
    case 'Archive':
      return 'Archivé';
  }
}

/** Libellé FR du rôle de l'auteur au moment de l'envoi (affiché en renfort du côté « moi »/contrepartie). */
export function senderRoleLabel(role: ChatSenderRole): string {
  switch (role) {
    case 'Admin':
      return 'JeKo';
    case 'Master':
      return 'Contact principal';
    case 'Collaborateur':
      return 'Collaborateur';
  }
}
